// 判断容器类型
function detectContainer() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("micromessenger")) return "wechat";
  if (ua.includes("alipayclient")) return "alipay";
  if (ua.includes("baiduboxapp")) return "baidu";
  if (ua.includes("jingtongapp")) return "jingtongapp";
  return "web"; // 默认
}
// 存储各平台 SDK 加载状态
const sdkLoaders = {};
/**
 * 动态加载容器 SDK 并返回适配层
 * @param {Object} options - success/fail 回调
 * @returns {void}
 */
export default function loadSdk({ success = () => {}, fail = () => {} } = {}) {
  const container = detectContainer();
  if (container === "web") {
    console.log("请在指定容器环境中打开页面");
    return;
  }
  // 1. 复用已加载的 SDK
  if (sdkLoaders[container]) {
    console.log(`✅ 复用已加载的 ${container} SDK`);
    sdkLoaders[container].then(success).catch(fail);
    return sdkLoaders[container];
  }
  // 2. 创建加载 Promise
  const sdkPromise = new Promise((resolve, reject) => {
    // 平台脚本配置
    const platformScripts = {
      wechat: ["https://res.wx.qq.com/open/js/jweixin-1.6.0.js"],
      baidu: [
        "https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.31.js",
      ],
      alipay: [
        "https://appx/web-view.min.js",
        "https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js",
      ],
      jingtongapp: ["https://appjt/web-view.min.js"],
    };
    const scripts = platformScripts[container];
    if (!scripts) {
      reject(new Error(`No scripts configured for container: ${container}`));
      return;
    }
    // 动态加载单个脚本
    function loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Script load failed: ${src}`));
        document.body.appendChild(script);
      });
    }
    // 顺序加载所有脚本
    scripts
      .reduce(
        (chain, src) => chain.then(() => loadScript(src)),
        Promise.resolve()
      )
      .then(async () => {
        console.log(`✅ 【${container}】SDK 脚本加载完成`);
        try {
          const type = container == "jingtongapp" ? "jtapp" : container;
          const module = await import(`./jssdk/${type}.js`);
          resolve(module.default);
        } catch (importError) {
          console.error(
            `❌ 动态导入 ./jssdk/${container}.js 失败`,
            importError
          );
          reject(importError);
        }
      })
      .catch(reject);
  });
  // 缓存 Promise，避免重复加载
  sdkLoaders[container] = sdkPromise;
  // 兼容回调
  sdkPromise.then(success).catch(fail);
  return sdkPromise;
}



// WEBPACK FOOTER //
// ./src/utils/newJtjssdk/jingtongsdk.js